import React from 'react'

// import {getSpotifyUriFromTrackInfo} from '../../util/track-utils'
// import {selectCurrentTrackImageUrl} from '../../selectors/session-selectors'

import { TrackInfo } from '../../types'
import { getTrackPoints, difficultyString } from '../../util/score-utils'
import Util from '../../util/util'

type Props = {
  trackInfo?: TrackInfo
  title?: string
  scoreVersion?: number
}
const TrackBadge: React.FC<Props> = ({ trackInfo, title: cellTitle, scoreVersion = 2 }) => {
  if (!trackInfo) {
    return (
      <div className="total">
        <div>{cellTitle}</div>
      </div>
    )
  }
  const {
    // slug: trackSlug,
    title = '[no track]',
    artist,
    wordCount,
    duration,
    emptyAirtime,
  } = trackInfo
  // const spotifyUri = getSpotifyUriFromTrackInfo(trackInfo)
  // const isUseSpotifyImage = hasSpotifyToken && spotifyUri
  // const trackImageUrl = useAppSelector(selectCurrentTrackImageUrl)
  const possibleTitleParts = title.split(' | ')
  const [trackArtist, trackTitle] =
    possibleTitleParts.length === 2 ? possibleTitleParts : [artist, title]
  const trackPointInfo = () => {
    const durationClockTime = Util.secondsToClock(duration, false, false)
    const scoreDuration = scoreVersion < 2 ? duration : duration - emptyAirtime
    const { wordDensity } = getTrackPoints(wordCount, scoreDuration)
    const difficultyStr = duration > 0 ? difficultyString(wordDensity) : '-'
    const durationStr = duration > 0 ? durationClockTime : '-'
    const divider = <span>{' / '}</span>

    return (
      <div className="trackInfo">
        <div className="pointInfo">
          <span>{durationStr}</span>
          {divider}
          <span>{wordCount}</span>
        </div>
        <div className="pointInfo">
          <span>{difficultyStr}</span>
        </div>
      </div>
    )
  }
  const tabIndex = -1 // TODO: passed-in onClick prop?
  return (
    <div className="trackBadge">
      {/*{isUseSpotifyImage && (*/}
      {/*  <div className="spotifyInfo">*/}
      {/*    <img src={trackImageUrl} alt="" />*/}
      {/*  </div>*/}
      {/*)}*/}
      <div className="currTrackTitle">
        <button className="title" tabIndex={tabIndex}>
          {trackTitle}
        </button>
        <span className="artist">{trackArtist}</span>
      </div>
      {trackPointInfo()}
    </div>
  )
}

export default TrackBadge
